export function requestIdle(fn, timeout = 150) {
  if (typeof window.requestIdleCallback === "function") {
    return window.requestIdleCallback(fn, { timeout });
  }
  return setTimeout(() => fn({ didTimeout: false, timeRemaining: () => 0 }), timeout);
}
export function cancelIdle(id) {
  if (typeof window.cancelIdleCallback === "function") {
    window.cancelIdleCallback(id);
  } else {
    clearTimeout(id);
  }
}
